// extracted by mini-css-extract-plugin
export default {"content":"-gagDBit1f5wXr8+KHoQsw==","text":"VmaFWVsm3wcqIDdT5k-WJg==","restoreNotice":"guNtOasAGmWb1CE1xUeTGg==","buttonHolder":"JzJ8xSngIxQ8f0UNcDp5Ww=="};